<template>
  <!--创建合同-->
  <div>
    <div class="info-all">
      <!--左侧-->
      <el-aside
        width="2rem"
        class="aside-left"
        :style="{ height: boxHeightOld }"
      >
        <p class="page-total">
          <span class="tit">签署文件列表</span>
          <span>共{{ fileList.length }}个</span>
        </p>
        <div class="aside-left_flex">
          <div class="page-con">
            <template v-for="(file, i) in fileList">
              <div
                :key="i"
                @click="chooseFile(file, i)"
                :class="checkAct === i ? 'active' : ''"
                class="list"
              >
                <el-tooltip effect="light" placement="right-start">
                  <div slot="content">此文件设置有签署位置</div>
                  <i v-show="filePage(file)" class="icon icon-status_sign"></i>
                </el-tooltip>
<!--                          @click="InOnlyOffice(file, i)"-->
<!--                <span-->
<!--                  class="tpl-icon tpl-posi"-->
<!--                  style="z-index: 1"-->
<!--                  v-show="-->
<!--                  beWord(file.fileName) || (file.useTo && file.useTo === 1)-->
<!--                "-->
<!--                >编辑</span-->
<!--                >-->
                <div class="bx">
                  <img :src="fileIcon(file)" />
                </div>
                <p class="title" :title="file.fileName">{{ file.fileName }}</p>
              </div>
            </template>
          </div>
<!--          <div>-->
<!--            <transition name="el-zoom-in-top">-->
<!--              <div-->
<!--                class="list-pages"-->
<!--                :style="{ height: leftCSideHeight }"-->
<!--              >-->
<!--                <template v-for="i in contractInfoTemporary.items">-->
<!--                  <div-->
<!--                    @click="getContractDetailByNum(i)"-->
<!--                    :class="currentInfo.page === i ? 'active' : ''"-->
<!--                    :key="i"-->
<!--                    class="listDetail"-->
<!--                  >-->
<!--                    <img-->
<!--                      v-if="contractList[i] && contractList[i].url"-->
<!--                      :src="contractList[i].url"-->
<!--                    />-->
<!--                    <img v-else src="/images/contr_default.jpg" alt="" />-->
<!--                    <span>{{ i }}</span>-->
<!--                  </div>-->
<!--                </template>-->
<!--              </div>-->
<!--            </transition>-->
<!--          </div>-->
        </div>
      </el-aside>
      <transition name="el-fade-in">
        <div
          class="aside"
          :style="{ height: boxHeightOld }"
          v-show="drawerShow"
        ></div>
      </transition>
      <transition name="my">
        <div
          class="aside-content"
          :style="{ height: boxHeightOld }"
          v-show="drawerShow"
        >
          <div class="aside-top">
            仅供参与方查阅，不用于签署（共
            {{ this.enclosureFilesList.length }} 份）
            <span class="el-icon-error" @click="drawerShow = false"></span>
          </div>
          <div class="aside-box" :style="{ height: windowHeight - 120 + 'px' }">
            <div class="enclosure-box">
              <div
                class="enclosure-item"
                v-for="(item, index) in enclosureFilesList"
                :key="index"
              >
                <!--预览-->
                <div class="li-preview">
                  <!--图片和video预览-->
                  <span
                    class="el-icon-view"
                    title="预览"
                    v-if="isImg(item) || isVideo(item)"
                    @click="previewVideOrImg(item)"
                  ></span>
                  <!-- 文档预览-->
                  <span
                    class="el-icon-view"
                    title="预览"
                    v-if="isDoc(item)"
                    @click="previewDoc(item)"
                  ></span>
                  <a :href="downloadAttatchFile(item)" target="_blank">
                    <span class="el-icon-download" title="下载"></span>
                  </a>
                </div>
                <div class="li-con">
                  <div class="t-do">{{ getEnclosureSuffix(item) }}</div>
                  <h1 :title="item.fileName">{{ item.fileName }}</h1>
                </div>
              </div>
            </div>
            <no-data
              v-if="enclosureFilesList.length === 0"
              text="暂无数据"
              slot="empty"
            />
          </div>
        </div>
      </transition>
      <div class="aside-tab" :class="drawerShow ? 'open' : 'close'">
        <div class="tab" @click="openTab" :class="drawerShow ? 'active' : 'active'">
          <i class="el-icon-circle-plus"></i>
          <span class="word">附属材料&nbsp;&nbsp;</span>
          <i
            :class="drawerShow ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
          ></i>
        </div>
      </div>
      <!--合同显示详情-->
      <el-main class="main-content" v-if="fileList[checkAct]">
        <template v-if="beWord(fileList[checkAct].fileName) || (fileList[checkAct].useTo && fileList[checkAct].useTo === 1)">
          <div class="top_btn">
            <div class="btn_class" @click="backDraftFn()">回到草稿箱</div>
            <div class="right_btn">
<!--              <div class="btn_class" @click="saveLoading">保存并预览当前文件</div>-->
              <div class="btn_class" @click="inviteReview()">继续邀请他人进行审阅 +</div>
              <el-button size="mini" type="primary" @click="backStep">终止审阅并发起</el-button>
            </div>
          </div>
          <only-office
            v-if="showofficeEditor"
            :editor="editor.editorConfig"
            class="office-box"
          ></only-office>
        </template>
        <template v-else>
          <contract-view
            ref="contractView"
            :contract-info.sync="currentInfo"
            :chapter-list.sync="chapteJson"
            :items="contractInfoTemporary.items"
            :page="currentInfo.page"
            :scaleValue.sync="scaleValue"
            :targetId="contractInfoTemporary.targetId"
            :show-chapter="true"
            :isDetail="true"
            @del-chapte="delChapteByCindex($event)"
            :signatory-json="signatoryJson"
            @pre-page="getContractDetailByNum($event)"
            @next-page="getContractDetailByNum($event)"
            @changeSmallMap="changeSmallMap"
            @toCurrentPage="toCurrentPage"
          />
        </template>
      </el-main>
      <!--右侧-->
      <el-aside
        v-if="fileList[checkAct] && !(beWord(fileList[checkAct].fileName) || (fileList[checkAct].useTo && fileList[checkAct].useTo === 1))"
        width="2.80rem"
        class="aside-right"
        :style="{ height: boxHeightOld }"
      >
        <div class="right-bottom">
          <el-button
            v-show="
             contractInfoTemporary &&
              contractInfoTemporary.items &&
              contractInfoTemporary.items > 1 &&
                  ((beWord(fileList[checkAct].fileName) ||
                    (fileList[checkAct].useTo &&
                      fileList[checkAct].useTo === 1)) &&
                  !$route.query.multiFileKey)
                "
            type="primary" size="mini"
            @click="InOnlyOffice(fileList[checkAct], checkAct)"
          >编辑</el-button
          >
          <el-button @click="backDraftFn()" type="primary" size="mini"
            >回到草稿箱</el-button
          >
          <el-button @click="inviteReview()" type="primary" size="mini"
            >继续邀请他人进行审阅</el-button
          >
          <el-button @click="getUpFiles(checkAct)" size="mini" type="primary"
            >刷新合同</el-button
          >
          <el-button @click="backStep" size="mini" type="primary"
            >终止审阅并发起</el-button
          >
        </div>
      </el-aside>
    </div>
    <!-- onlyOffice -->
<!--    <editor-pup-->
<!--      :showofficeEditor.sync="showofficeEditor"-->
<!--      :editor="editor"-->
<!--      @saveLoading="saveLoading"-->
<!--    ></editor-pup>-->
    <!-- 邀请他人审阅弹窗 -->
    <cooper-pup
      :cooperVisi.sync="cooperVisi"
      :darfPhoneList="coEditingInfos"
      @saveAndJump="continueReview"
    ></cooper-pup>
    <!--pdf文件预览-->
    <ViewFilesToDoc
      :visibleShow="visibleShowEnclosureDoc"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      @setViewFilesToDocDialogData="onSetViewFilesToDocDialogData"
    />
  </div>
</template>

<script>
// API
import {
  ApiMethods,
  convertDetailToShow,
  fileOperShow,
  getFindFileDownload,
  tempConvertToContract,
} from "../../../../assets/js/http-serve/http-methods";
import {
  happy,
} from "../../../../assets/js/lib/valid-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";

// tool
import { isInDingTalk } from "../../../../assets/js/utils/ding-env";
// components
import Flow from "../../../../components/flow";
import draggable from "vuedraggable";
import SingerForm from "../../../../components/singer-form";
import ToolTip from "../../../../components/tool-tip";
import ContractView from "../../../../components/contract-view/index";
import SignInfoTipsDialog from "../../../../components/contract/signInfoTipsDialog";
import ViewFilesToDoc from "@/components/viewFiles/ViewFilesToDoc";
import ViewFilesToImg from "@/components/viewFiles/ViewFilesToImg";
import waterMark from "@/components/waterMark/index";
import dialogPup from "../dialogPup.vue";
import tplSetting from "../tplSetting.vue";
import moreSetting from "../moreSetting.vue";
import regularPup from "../regularPup.vue";
import editorPup from "../../../../components/onlyOffice/editorPup.vue";
import flowPath from "../dingTalkuse/flowPath.vue";
import selfSelection from "../dingTalkuse/selfSelection.vue";
import cooperPup from "../cooperateWith/cooperPup.vue";
import onlyOffice from "../../../../components/onlyOffice/index.vue";

export default {
  props: {
    cooperateInfo: {
      type: Object,
      default: {
        draftCoEditingSec: {}
      }
    },
  },
  data () {
    return {
      coEditingInfos: [],
      upFiles: null, // 发起时上传的文件和附件
      cooperVisi: false, // 邀请审阅弹窗
      textcontent:
        "将发送协同编辑链接给他人，收到链接的人可编辑合同内容，编辑结果实时查看（仅doc、docx格式文件可编辑）",
      // 钉钉环境使用变量 start
      isInDingTalk,
      // 钉钉环境使用变量 end
      showofficeEditor: false,
      editor: {},
      templateAPI: ApiMethods.templateAPI,
      contractBackUrl: "", // api发起合同页面跳转
      happy, // 正则
      goPageNum: null, // 前往多少页
      // 是否是集团账户
      isGroup: false,
      apiMethods: ApiMethods,
      // 合同信息
      contractInfo: {
        //判断是否是草稿箱回来
        applyIdSec: "",
        //批量签署方 批量发起签署顺序1-n ,当前批量的签署顺序,顺序签
        batchSignOrder: 0,
        //主题名称
        contractName: "",
        // 批量签署方信息
        batchSigners: [],
        //自定义抄送，高级版才有
        carbonCopy: [],
        //付费方式
        consumMode: 0,
        //上传的文件和附件集合
        files: [],
        //审批流程ID，高级版才有
        flowId: 0,
        // 顺序签
        ifOrder: false,
        /**
         * 是否使用骑缝章
         * @value 0 不要企业和个人骑缝章（两个都不打钩）
         * @value 1 企业和个人都有骑缝章（两个都打钩）
         * @value 2 企业打钩个人不打钩
         * @value 3 企业不打钩个人打钩
         * */
        needQifengSign: 1,
        // 保全章
        needPresSign: 1,
        //是否使用视频签署 1使用
        needVideoSign: 0,
        //合同截止时间
        overDate: "",
        //是否支付,1是支付，其他查询消耗的积分数
        pay: 0,
        //是否保存到草稿
        saveToDraftBox: false,
        //是否云证书
        serverCa: 1,
        //签字链接有效期
        signExpire: "",
        // 正常签署方
        signers: [],
        draftChapteJson: [],
        // 视频签署
        newNeedVideoSign: "", // 是否使用视频签署
        videoSignStartTime: "", // 开始时间
        hideSignDate: 0 // 签章时间
      },
      // 临时展示合同信息
      contractInfoTemporary: {},
      // 合同列表临时保存当前合同信息
      contractList: {},
      signatoryJson: [
        {
          faceOrVideo: null, // 用户是否选中视频通话
          // 签署方信息邮箱或者电话
          account: "",
          authLevel: null,
          userType: 0,
          // 签章位置
          chapteJson: [],
          // 身份信息或者企业id
          identityNo: "",
          mobile: "",
          // 签章等级
          signLevel: null,
          // 签署方名称
          name: "",
          corpUser: "",
          videoSignUserType: "", // 视频签署，签署方类型，1: 参与者，2: 主持者
          readTime: null, // 强制阅读
          businessLicense: "",
          // 辅助变量
          // 新增集团账户 数组
          corpUserStatus: false,
          canSelectArray: [],
          canSelectArrayIndex: 0,
          signatoryUserType: 0,
          ischange: 0,
          signOwner: "签署方一",
          disabled: "",
          openUserTab: false,
          isEncrypt: false,
          isNoticePhone: false,
          showNoticePhone: false
        }
      ],
      // 签章参数 {page: 0合同第几页, chaptes:[签章位置{offsetX: '0.5', offsetY: '0.5', cindex: 0章顺序不分甲乙方和页数, signOwner: 甲乙方, url: 章地址， page: 0合同页数}]}
      chapteJson: [],
      boxHeight: "1170px",
      boxHeightOld: "1170px",
      windowHeight: 798,
      leftCSideHeight: 0,
      // 当前页信息
      currentInfo: { page: 1, url: "" },
      loading: null,
      // 小地图 拖动相对位移
      deviationSmallMap: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        clientWidth: 0,
        clientHeight: 0
      },
      // 合同缩放比例
      scaleValue: 100,
      // 上传附件数组
      enclosureFilesList: [],
      // 文件上传列表
      fileList: [],
      // copy 文件上传列表 （含有模板发起步骤，点击上一步做数据回显)
      copyTemp: [],
      //图片转换接口
      fileOperShow: fileOperShow,
      // pdf 预览
      visibleShowEnclosureDoc: false,
      //其他 文件预览
      visibleShowEnclosure: false,
      enclosurePreviewNumItem: {}, // 当前预览项
      checkAct: -1, // 当前显示合同选中文件
      isRefresh: true, // 预览附件时，强制刷新
      drawerShow: false, //侧边展示
      fileImgName: "",
      fileImgShow: true,
      PDFImg: require("../../../../static/images/advancedVersion/pdf.png"),
      JPGImg: require("../../../../static/images/advancedVersion/JPG.png"),
      XLSImg: require("../../../../static/images/advancedVersion/xlsx.png"),
      DOCImg: require("../../../../static/images/advancedVersion/word.png"),
      WPSImg: require("../../../../static/images/advancedVersion/WPS.png"),
      TPLImg: require("../../../../static/images/advancedVersion/tpl.png")
    };
  },
  computed: {
    filePage () {
      return function (file) {
        if (this.chapteJson.length > 0) {
          let arr = this.chapteJson.filter(v => {
            const VO = file.fileOperVO;
            v.targetId === VO ? VO.targetId : file.targetId;
          });
          return arr.length > 0 ? true : false;
        }
      };
    },
  },
  created () {
    let v = this.$store.getters.currentAuthUser;
    if (v && v.corpUserId) {
      this.isGroup = true;
    }
    this.getUpFiles();
  },
  mounted () {
    // this.boxHeight = document.body.clientHeight - 60 + "px";
    this.boxHeight = document.body.clientHeight - 100 + "px";
    this.boxHeightOld = document.body.clientHeight - 60 + "px";
    this.leftCSideHeight =
      document.body.getBoundingClientRect().height - 60 + "px";
    this.windowHeight = document.body.getBoundingClientRect().height;
    const { multiSignatoryKey } = this.$route.query,
      authUser = this.$store.getters.authUser,
      account = authUser.mobileMash || authUser.emailMask;
  },
  methods: {
    // 执行预览PDF关闭后参数回传
    onSetViewFilesToDocDialogData (data) {
      this.visibleShowEnclosureDoc = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // * 协同编辑【1406】
    continueReview (phoneList) {
      const { isGroup } = this, { draftCoEditingSec } = this.cooperateInfo;
      const InviteAPI = isGroup ? ApiCorpMethods.cooperateWithAPI.InviteCollaboration : ApiMethods.cooperateWithAPI.InviteCollaboration,
        params = { draftCoEditingSec, coEditingUsers: JSON.stringify(phoneList) };
      InviteAPI(params).then(res => {
        this.getUpFiles()
        if (!res.success) return this.$message.error(res.description)
      })
    },
    //backDraftFn
    backDraftFn () {
      if (this.$store.getters.currentAuthUser.corpUserId) {
        this.$router.push('/corp/signInfo/applyList?signStatus=4')
      } else {
        this.$router.push('/signInfo/applyList?signStatus=4')
      }
    },
    // 继续邀请他人审阅
    inviteReview () {
      this.cooperVisi = !this.cooperVisi;
    },
    // 获取文件
    getUpFiles (checkAct) {
      const InfoAPI = this.isGroup
        ? ApiCorpMethods.cooperateWithAPI.getEditInfo
        : ApiMethods.cooperateWithAPI.getEditInfo;
      const { draftCoEditingSec } = this.cooperateInfo;
      InfoAPI({ draftCoEditingSec }).then(res => {
        if (!res.success) return this.$message.error(res.description);
        this.coEditingInfos = res.data.coEditingInfos
        const files = res.data.files;
        const upFiles = [];
        files.forEach(file => {
          if (file.fileType === 1) {
            if (file.sourceFile) {
              let target = file.sourceFile.targetId;
              let first = target.lastIndexOf("."); //取到文件名开始到最后一个点的长度
              let namelength = target.length; //取到文件名长度
              let filesuffix = target.substring(first, namelength); //截取获得后缀名
              file.fileName = file.fileName.split(".")[0] + filesuffix;
            }
            upFiles.push(file)
          }
          if (file.fileType === 2) {
            this.enclosureFilesList.push(file)
          }
        });
        console.log('upFiles', upFiles);
        this.fileList = upFiles;
        const index = checkAct > -1 ? checkAct : 0;
        this.officePDFInfo(
          Object.assign(this.fileList[index].sourceFile, {
            fileName: this.fileList[index].fileName
          }),
          index
        );
      });
    },
    // 调用loading并获取原文件
    saveLoading () {
      let sourceFile = this.editor.sourceFile,index = this.checkAct;
      this.loadingStart();
      const accountAPI = this.isGroup ? ApiCorpMethods : ApiMethods, { draftCoEditingSec } = this.cooperateInfo;
      const param = {
        draftCoEditingSec,
        fileKey: sourceFile.fileKey
      }
      accountAPI.cooperateWithAPI.closeFile(param).then(res => {
        if (!res.success) return this.$message.error(res.description)
        setTimeout(() => {
          // this.loadingClose();
          ApiMethods.onlyOfficeAPI.officeFile(sourceFile).then(res => {
            if (!res.success) {
              this.loadingClose()
              return this.$message.error("网络异常，请重试");
            }
            this.officePDFInfo({...res.data, fileKey: sourceFile.fileKey}, index, 'preview');
          });
        }, 10 * 1000);
      }).catch(() => {
        this.loadingClose()
      })
    },
    // // 获取office编辑后的文件
    // editedFile (sourceFile, index) {
    //   this.getUpFiles(this.checkAct)
    // },
    // onlyoffice 编辑
    InOnlyOffice (file, index) {
      const sourFile = file.sourceFile;
      this.chapteJson = [];
      this.loadingStart();
      const API = this.isGroup
        ? ApiCorpMethods.cooperateWithAPI.ObtainCollaboration
        : ApiMethods.cooperateWithAPI.ObtainCollaboration,
        { draftCoEditingSec } = this.cooperateInfo,
        params = { draftCoEditingSec, fileKey: sourFile.fileKey };
      API(params)
        .then(res => {
          if (!res.success) return this.$message.error(res.description);
          const { data } = res,
            { sourceFile } = file;
          this.editor = {
            editorConfig: Object.assign(
              { width: "100%", height: this.boxHeight },
              data
            ),
            sourceFile,
            fileIndex: index
          };
          this.showofficeEditor = true;
        })
        .finally(() => {
          this.loadingClose();
        });
    },
    // 判断文件是否是doc类型
    beWord (fileName) {
      let filesuffix = "";
      if (fileName) {
        let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        let namelength = fileName.length; //取到文件名长度
        filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      }
      return filesuffix === "doc" || filesuffix === "docx";
    },
    // 结束审阅
    backStep () {
      const _this = this, { isGroup, fileList, enclosureFilesList } = this;
      const params = { draftCoEditingSec: _this.cooperateInfo.draftCoEditingSec };
      const accountAPI = isGroup ? ApiCorpMethods : ApiMethods;
      _this.loadingStart()
      // * 1.先结束协同
      accountAPI.cooperateWithAPI.endAllFile(params).then(res => {
        if (!res.success) return _this.$message.error(res.description)
        setTimeout(() => {
          // * 2. 再结束审阅
          accountAPI.cooperateWithAPI.endReview(params).then(res => {
            if (!res.success) return _this.$message.error(res.description)
            _this.$emit('finishCooperate', { fileList, enclosureFilesList })
          }).finally(() => { _this.loadingClose() })
        }, 8 * 1000);
      }).catch(() => { _this.loadingClose() })
    },
    fileIcon (file) {
      let filesuffix = "tpl",
        fileName = file.fileName;
      if (fileName) {
        let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        let namelength = fileName.length; //取到文件名长度
        filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      }
      switch (filesuffix) {
        case "pdf":
          return this.PDFImg;
        case "jpg":
          return this.JPGImg;
        case "doc":
        case "docx":
          return this.DOCImg;
        case "xls":
        case "xlsx":
          return this.XLSImg;
        case "tpl":
          return this.TPLImg;
        default:
          // wps
          return this.WPSImg;
      }
    },
    // 附属材料打开与关闭
    openTab () {
      this.drawerShow = !this.drawerShow;
      this.fileImgShow = this.drawerShow ? false : true;
    },
    // 存储文件的合同文件转换，非上传的临时文件转换
    convertContractToInfo (param) {
      const _this = this;
      _this.loadingStart("正在加载合同信息");
      tempConvertToContract(param)
        .then(({ data }) => {
          _this.loadingClose();
          _this.contractInfoTemporary = {
            docHash: data.docHash,
            ts: param.ts,
            sign: param.sign,
            items: parseInt(data.items),
            targetId: param.targetId
          };
          _this.fileImgName = param.fileName;
          _this.getContractDetailByNum(1);
        })
        .catch(err => {
          _this.loadingClose();
          console.error("合同文件转换 " + JSON.stringify(err));
        }).finally(() => { _this.loadingClose() });
    },
    // 获取附件后缀
    getEnclosureSuffix (item) {
      if (item && item.fileOperVO && item.fileName) {
        let arr = item.fileName.split(".");
        return arr[arr.length - 1];
      }
      return "";
    },
    // 附件下载
    downloadAttatchFile (param) {
      if (!param || param === "null" || param === "false")
        return "javascript:void(0)";
      if (param.fileName === "blob") {
        param.fileName = "attachment.png";
        param.fix = ".png";
      }
      let VO = param.fileOperVO;
      const files = {
        fileName: param.fileName,
        fileSize: VO.fileSize,
        fileType: VO.fileType,
        sign: VO.sign,
        targetId: VO.targetId,
        ts: VO.ts
      };
      return getFindFileDownload(files);
    },
    // 附件是否是图片
    isImg (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      let arr = ["PNG", "GIF", "JPG", "JPEG"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否是视频
    isVideo (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['MP4','RMVB','MKV','AVI']
      let arr = ["MP4", "WEBM", "OGG"];
      // let arr = ['MP4']
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否文档
    isDoc (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PDF"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 预览图片或者视频
    previewVideOrImg (item) {
      let files = {
        id: item.fileOperVO.targetId,
        file: {
          fileType: item.fileOperVO.fileType,
          sign: item.fileOperVO.sign,
          targetId: item.fileOperVO.targetId,
          ts: item.fileOperVO.ts,
          fileName: item.fileName
        }
      };
      this.enclosurePreviewNumItem = files;
      this.visibleShowEnclosure = true;
      // 刷新预览弹窗，更新
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    // 预览文档
    previewDoc (item) {
      let files = {
        id: item.fileOperVO.targetId,
        file: {
          fileType: item.fileOperVO.fileType,
          sign: item.fileOperVO.sign,
          targetId: item.fileOperVO.targetId,
          ts: item.fileOperVO.ts,
          fileName: item.fileName
        }
      };
      this.enclosurePreviewNumItem = files;
      this.visibleShowEnclosureDoc = true;
    },
    // 切换文件展示合同
    chooseFile (file, i) {
      if (this.beWord(file.fileName) && !file.noChoose) {
        const _file = {
          noChoose: 1,
          fileName: file.fileName,
          ...file.sourceFile
        }
        this.officePDFInfo(_file, i);
        return false
      }
      const { fileOperVO: VO } = file;
      const fileVO = VO ? VO : file;
      // if (this.checkAct === i) return;
      this.contractList = {};
      this.checkAct = i;
      if (this.beWord(file.fileName) || (file.useTo && file.useTo === 1)) {
        this.InOnlyOffice(file, i)
        this.convertContractToInfo(fileVO);
      } else {
        this.convertContractToInfo(fileVO);
      }
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    toCurrentPage (val) {
      let dom = document.querySelectorAll(".list-pages .listDetail")[val - 1];
      if (dom) {
        document.querySelectorAll(".list-pages")[0].scrollTop = dom.offsetTop;
      }
    },
    //  按页数获取合同，在左侧目录定位当前页，中间合同滚动到顶部从头展示
    goPageAndFixed (page) {
      this.getContractDetailByNum(page);
      this.toCurrentPage(page);
      document.querySelectorAll(".contract-view")[0].scrollTop = 0;
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    // 按页数获取合同
    getContractDetailByNum (num) {
      if (this.contractList[num]) {
        return (this.currentInfo = this.contractList[num]);
      }
      this.currentInfo = {
        page: num,
        url: convertDetailToShow({
          docHash: this.contractInfoTemporary.docHash,
          ts: this.contractInfoTemporary.ts,
          sign: this.contractInfoTemporary.sign,
          items: this.contractInfoTemporary.items,
          targetId: this.contractInfoTemporary.targetId,
          fileType: 3,
          fix: "png",
          num: num - 1
        })
      };
      if (!this.contractList[num]) {
        this.contractList[num] = this.currentInfo;
      }
    },
    changeSmallMap (val) {
      this.deviationSmallMap = val;
    },
    // 获取文件后缀
    fileSuffix (fileName) {
      let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let namelength = fileName.length; //取到文件名长度
      let filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      return filesuffix;
    },

    // 根据cindex删除签章
    delChapteByCindex (cindex) {
      if (!this.chapteJson.length) return;
      this.chapteJson = this.chapteJson.filter(t => t.cindex != cindex);
      this.listChapteJsonCindex();
    },
    // 给签章列表添加cindex
    listChapteJsonCindex () {
      if (!this.chapteJson.length) return;
      for (let i = 0; i < this.chapteJson.length; i++) {
        this.chapteJson[i].cindex = i;
      }
    },
    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // office编辑后转换
    officePDFInfo (fileInfo, index, preview) {
      // this.loadingStart();
      const { fileName, targetId, fileType } = fileInfo;
      ApiMethods.AIDocSmart.converToPDF({ ...fileInfo }).then(res => {
        const { data } = res;
        if (res.success) {
          const file = {
            fileName: fileName,
            fileType: 1,
            tempFile: data.tempFile,
            items: data.items,
            sort: null,
            fileOperVO: {
              docHash: data.docHash,
              extendsLocation: "",
              fileName: fileName,
              fileType: 3,
              sign: data.tempFile.sign,
              targetId: data.tempFile.targetId,
              targetIdForPreview: "",
              ts: data.tempFile.ts
            },
            sourceFile: fileInfo
          };
          if (index >= 0) {
            this.$set(this.fileList, index, file);
          } else {
            this.fileList.push(file);
          }
          const { noChoose } = fileInfo
          this.chooseFile({ ...this.fileList[index], noChoose }, index);
          if (preview) {
            this.previewDoc(this.fileList[this.checkAct])
          }
        } else {
          this.$message.error(res.description);
        }
        this.loadingClose();
      });
    }
  },
  components: {
    ContractView,
    // ToolTip,
    // SingerForm,
    // draggable,
    // Flow,
    // SignInfoTipsDialog,
    ViewFilesToDoc,
    // ViewFilesToImg,
    // waterMark,
    // dialogPup,
    // tplSetting,
    // moreSetting,
    // regularPup,
    editorPup,
    // flowPath,
    selfSelection,
    cooperPup,
    onlyOffice,
  },
  head: { title: "文件发起签署" },
  layout: "fullpage"
};
</script>
<style lang="less">
.el-dialog {
  margin-top: 50px !important;
}
</style>
<style scoped>
.el-button:hover {
  color: #ffffff !important;
}
</style>
<style lang="less" scoped>
.contract-bottom {
  position: absolute;
  bottom: 110px;
  right: 0;
  width: 40px;
  height: auto;
  pointer-events: none;
  z-index: 8;
}
.info-all {
  min-height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-width: 0;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: #f5f5f5;
}
.file-img-btn {
  /*position: absolute;*/
  z-index: 102;
  // top: 60px;
  /*left: 2.8rem;*/
  width: 1.8rem;
  height: 30px;
  background-color: #eb1b1b;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 20px 0 10px;
  color: #ffffff;
  cursor: pointer;
  strong.file-arrow {
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    top: 8px;
    right: 4px;
  }
}
.list-pages::-webkit-scrollbar {
  width: 0;
}
.list-pages {
  flex-shrink: 0;
  /*position: absolute;*/
  z-index: 112;
  /*margin: 0 auto;*/
  padding-top: 0.2rem;
  padding-left: 0.1rem;
  padding-right: 0.1rem;
  color: #323232;
  overflow-y: auto;
  width: 1.6rem;
  height: 7rem;
  /*top: 30px;*/
  /*left: 2.8rem;*/
  background-color: #ffffff;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);

  i.icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 0.4rem;
    height: 0.4rem;
    background-size: cover;
    cursor: pointer;
    z-index: 1;
  }

  span {
    position: absolute;
    bottom: 0px;
    right: 0;
    display: block;
    width: 0.4rem;
    height: 0.3rem;
    line-height: 0.3rem;
    color: #fff;
    background-color: #e3e3e3;
    text-align: center;
    border-radius: 0.06rem 0px 0px 0px;
  }

  img {
    max-height: 3rem !important;
    width: 100%;
    box-sizing: border-box;
    /*margin-bottom: 10px;*/
    border: 0.02rem solid #e3e3e3;
  }

  .listDetail {
    position: relative;
    /*margin: 0 30px 20px 30px;*/
    margin-bottom: 0.2rem;
    cursor: pointer;
  }

  .active {
    img {
      border-color: #ec1c1c;
    }

    span {
      background-color: #ec1c1c;
    }
  }
}
// 新版样式

.tpl-icon {
  position: absolute;
  color: #fff;
  background-color: #ec1c1c;
  padding: 1px 3px;
  border-radius: 4px;
  font-size: 12px;
}
.tpl-posi {
  top: 0;
  left: 0;
}
.enclosureFiles {
  width: 100%;
  display: flex;
  align-items: center;
  height: auto;
  flex-wrap: wrap;

  .enclosureFiles-upload {
    width: 170px;
    height: 30px;
    border: 1px solid #888888;
    border-radius: 4px;
    margin: 15px;

    .box {
      width: 168px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-icon-paperclip {
        font-size: 20px;
        margin-right: 10px;
      }
    }
  }

  .enclosureFiles-item {
    width: 170px;
    height: 30px;
    border-radius: 4px;
    background-color: #efefef;
    margin: 15px;
    position: relative;

    .desc {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 10px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #290202;
      width: 170px;
      height: 30px;
      line-height: 30px;
      box-sizing: border-box;
    }

    .del-btn {
      font-size: 20px;
      position: absolute;
      right: -11px;
      top: -11px;
      width: 22px;
      height: 22px;
      color: #888888;
      cursor: pointer;
    }
  }
}

.more-set {
  cursor: pointer;
  font-size: 14px;
  color: #999;
}

.page-number {
  width: 120px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 2;
  right: 0px;
  top: 14px;
  border: 1px solid #dcdcdc;

  input {
    width: 70px;
    box-sizing: border-box;
    height: 30px;
    border: 0;
    background-color: transparent;
    outline: none;
    font-size: 12px;
    color: #290202;
    text-align: center;
  }

  .inp-in {
    width: 50px;
    height: 32px;
    line-height: 32px;
    display: block;
    background-color: #646464;
    text-decoration: none;
    cursor: pointer;
    box-sizing: border-box;
    border-radius: 0px 0.04rem 0.04rem 0.04rem;
    color: #fff;
    font-family: PingFang SC;
    text-align: center;
  }
}

.aside {
  position: absolute;
  top: 0px;
  width: calc(100% - 2.8rem);
  z-index: 100;
  left: 2.8rem;
  background-color: rgba(0, 0, 0, 0.6);
}

.aside-tab {
  width: 32px;
  height: auto;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  z-index: 102;

  .tab {
    width: 32px;
    height: 135px;
    writing-mode: vertical-lr;
    font-size: 12px;
    color: #a1a1a1;
    background-color: #fff;
    border-radius: 0 10px 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);

    .word {
      margin: 5px 0;
    }
  }

  .tab.active {
    color: #eb090a;
  }
}

.aside-tab.open {
  left: calc(800px + 2rem);
}

.aside-tab.close {
  /*left: 2.45rem;*/
  left: 1.9rem;
  z-index: 103;
}

.aside-content {
  position: absolute;
  top: 0px;
  left: 2rem;
  width: 800px;
  height: 100%;
  box-sizing: border-box;
  background-color: #eeeeee;
  z-index: 103;
  overflow: hidden;

  .aside-top {
    width: 100%;
    height: 60px;
    background-color: #f8f8f8;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    align-items: center;
    font-size: 12px;
    /*position: absolute;*/
    /*top: 0;*/
    /*left: 0;*/

    .el-icon-error {
      font-size: 20px;
      cursor: pointer;
      color: #646464;
    }
  }

  /*.aside-tab{
      width: 32px;
      height: auto;
      display: flex;
      flex-direction: column;
      position: absolute;
      right: -32px;
      top: 50%;
      transform: translateY(-50%);
      .tab{
        width: 32px;
        height: 135px;
        writing-mode: vertical-lr;
        font-size: 12px;
        color: #A1A1A1;
        background-color: #fff;
        border-radius: 0 10px 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .tab.active{
        color: #eb090a;
      }
    }*/

  .aside-box {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    position: absolute;
    overflow-y: auto;
    height: auto;

    .enclosure-box {
      display: flex;
      flex-wrap: wrap;

      .enclosure-item {
        width: 110px;
        height: 110px;
        margin: 10px;
        position: relative;

        &:hover {
          .li-preview {
            width: 100%;
            height: 100%;
            opacity: 1;
          }
        }

        .li-preview {
          cursor: default;
          font-weight: bold;
          overflow: hidden;
          background: rgba(0, 0, 0, 0.7);
          opacity: 0;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all ease-in 0.2s;
          z-index: 3;
          color: #ffffff;
          font-size: 18px;

          span {
            color: #ffffff;
            margin-top: -20px;
            display: inline-block;
            cursor: pointer;
            font-weight: bold;
            margin-right: 20px;

            &:last-child {
              margin-right: 0;
            }
          }

          a {
            margin-top: -20px;
            display: inline-block;
          }

          img {
            width: 100%;
            height: auto;
          }
        }

        .li-con {
          box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);
          line-height: 90px;
          text-align: center;
          /*position: relative;*/
          width: 100%;
          height: 100%;
          overflow: hidden;

          img {
            max-width: 100%;
            max-height: 100%;
          }

          h1 {
            cursor: default;
            z-index: 4;
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            background: rgba(0, 0, 0, 1);
            height: 20px;
            text-align: center;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: rgba(255, 255, 255, 1);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            opacity: 0.7;
            box-sizing: border-box;
            padding: 0 5px;
          }

          .t-do {
            line-height: initial;
            padding-top: 30px;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            color: #646464;
            font-weight: bold;
            font-size: 20px;
            font-family: PingFang SC;
            text-align: center;
            background: url("../../../../assets/images/bg-repeat.png") repeat;
            background-size: contain;
          }
        }
      }
    }
  }
}

.main-content {
  position: relative;
  display: table-cell;
  box-sizing: border-box;
  vertical-align: top;
  padding: 0;
  /*background: #ffffff;*/
  overflow: hidden;
  .top_btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 20px;
    .btn_class {
      border-radius: 4px;
      cursor: pointer;
      background-color: #e4c4c2;
      color: #ec1c1c;
      padding: 2px 10px;
      margin-right: 10px;
      &:hover {
        background-color: #ec1c1c;
        color: #ffffff;
      }
    }
    .right_btn {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .accessory-box {
    position: absolute;
    bottom: -106px;
    width: 100%;
    pointer-events: none;

    .accessory-list {
      pointer-events: initial;
      position: relative;
      width: 100%;
      /*display: flex;*/
      /*justify-content: flex-start;*/
      /*flex-wrap: wrap;*/
      /*align-items: center;*/
      box-sizing: border-box;
      // border-top: 1px solid rgba(0,0,0,0.16);
      padding: 56px 15px 20px 15px;
      background: #ffffff;
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);

      li {
        /*flex: none;*/
        /*display: table-cell;*/
        /*width: 100%;*/
      }

      .accessory-group {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;

        p.list-item {
          display: inline-block;
          position: relative;
          margin: 4px 25px 4px 0;
          padding: 6px 19px 6px 5px;
          // border: 4px;
          font-size: 12px;
          color: #000000;
          background: rgba(248, 248, 248, 1);

          > span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 200px;
          }
        }

        i.del {
          color: #a1a1a1;
          position: absolute;
          right: -6px;
          top: -6px;
          font-size: 16px;
          cursor: pointer;
        }
      }

      .upload-accessory {
        /*width: 75px;*/
        overflow: hidden;
        position: relative;
        cursor: pointer;
        display: inline-block;

        &:hover {
          opacity: 0.5;
        }

        a {
          // font-size:16px;
          display: inline-block;
          width: 120px;
          line-height: 35px;
          color: #ec1c1c;
          font-weight: bold;
        }

        &:hover a {
          font-weight: 800;
        }

        /*input {*/
        /*  position: absolute;*/
        /*  width: 300px;*/
        /*  height: 300px;*/
        /*  top: -18px;*/
        /*  left: -73px;*/
        /*  cursor: pointer;*/
        /*  opacity: 0;*/
        /*}*/

        .up-icon {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 5px;
        }

        .div-upload {
          /*cursor: pointer;*/
          border: 1px dashed #ec1c1c;
          width: 80px;
          height: 30px;
          line-height: 30px;
          display: inline-block;
          text-align: center;
          color: #ec1c1c;
          font-size: 18px;
          font-weight: normal;
          position: relative;
          z-index: 2;
        }

        .input-upload {
          cursor: pointer;
          position: absolute;
          z-index: 3;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          opacity: 0;
        }
      }
    }

    div.btn {
      pointer-events: initial;
      display: inline-block;
      // width: 120px;
      // height: 35px;
      // line-height: 35px;
      padding: 0 10px;
      font-size: 14px;
      // color: #ffffff;
      // background: #a2a5ac;
      // border-radius: 3px 3px 0 0;
      cursor: pointer;
      width: 150px;
      height: 45px;
      line-height: 45px;
      background: rgba(255, 255, 255, 0.65);
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);
      border-radius: 6px 6px 0px 0px;
      color: #ec1c1c;
      font-size: 15px;
      font-weight: bold;

      .arrow {
        margin-left: 15px;
        font-size: 12px;
        font-weight: bold;
        vertical-align: middle;
        display: inline-block;
        margin-top: -2px;
      }
    }
  }
}

@mg: 0.2rem; // 左右side给中间合同流的间距
.aside-right {
  box-sizing: border-box;
  // padding: 20px 20px 0 20px;
  background-color: #ffffff;
  overflow: hidden;
  position: relative;
  box-shadow: -0.02rem 0px 0.16rem rgba(0, 0, 0, 0.12);
  /*z-index:3;*/
  margin-left: @mg;

  .page-total {
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    box-sizing: border-box;
    border-bottom: 1px solid #f2f2f2;
    width: 100%;
    display: flex;
    background-color: #ffffff;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 60px;
    z-index: 2;
  }

  .right-bottom {
    background-color: #ffffff;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    /*z-index: 2000;*/
    padding: 0.2rem 0.27rem;
    box-shadow: 0px -0.03rem 0.12rem rgba(0, 0, 0, 0.16);

    button {
      font-size: 12px;
      width: 100%;
      margin: 5px 0;
    }
  }

  .list-signers {
    position: absolute;
    bottom: 1.2rem;
    top: 60px;
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
    background-color: #ffffff;
    .step-box {
      box-sizing: border-box;
      width: 110px;
      height: 110px;
      margin: 20px auto;
    }
    .btn-right {
      // width: 108px;
    }

    .del-signer {
      margin-right: 0.05rem;
      font-size: 0.18rem;
      cursor: pointer;
      color: #a1a1a1;
    }

    .del-signer:hover {
      color: #ec1c1c;
    }

    .btn-left {
      width: 0.32rem;
      height: 0.32rem;
      line-height: 0.32rem;
      padding: 0;
      margin-right: -1px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .qy-wrap {
      box-sizing: border-box;
      padding-left: 0.2rem;
      padding-right: 0.25rem;
    }

    .row-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .dragbox {
        flex: auto;

        button {
          width: 100%;
        }
      }

      button {
        flex: auto;
      }
    }

    .btn-group {
      box-sizing: border-box;
      margin-top: 0.18rem;
      // width: 140px;
      width: 100%;
      padding-top: 28px;
      // padding: 20px 0;
      position: relative;
      display: inline-block;

      .user-show {
        position: absolute;
        top: 0;
        line-height: 1;
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;

        span {
          display: inline-block;
          // width: 120px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 2rem;
        }
      }
    }
  }

  .btn {
    width: 100%;
    margin: 0 0 0.14rem 0;
  }

  .qs-wrap {
    padding-top: 0.25rem;
    background: rgba(255, 255, 255, 1);
    /*box-shadow:0px 3px 12px rgba(0,0,0,0.06);*/
    position: relative;
    /*z-index: 5;*/

    /deep/ .el-checkbox__label {
      padding-left: 0.1rem;
      line-height: 0.19rem;
      font-size: 14px;
    }

    /deep/ .el-checkbox {
      margin-right: 0.3rem;
    }
  }

  .qs-box {
    // padding:30px 25px 34px 25px;
    padding: 0.2rem 0 0.24rem 0;

    > img {
      height: 0.48rem;
      cursor: pointer;
      /*width: max-content;*/
      margin-left: 0.25rem;
      /*min-width:280px;*/
      width: 2.35rem;

      &:hover {
        cursor: pointer;
        /*cursor: url(/images/icon/cursor.ico),pointer;*/
        opacity: 0.7;
      }
    }
  }

  .t2 {
    color: #000000;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
  }

  .t3 {
    color: rgba(0, 0, 0, 0.85);
    font-weight: normal;
    padding-left: 0.3rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.17rem;
    font-size: 12px;
  }

  .m-title {
    .t2();
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.17rem;
  }

  .icon-1 {
    vertical-align: middle;
    display: inline-block;
    text-align: center;
    width: 0.22rem;
    height: 0.22rem;
    line-height: 0.22rem;
    margin-right: 0.1rem;
    margin-left: 0.05rem;
    margin-top: -0.04rem;
    background: rgba(236, 28, 28, 1);
    border-radius: 50%;
    font-size: 0.16rem;
    color: #ffffff;
    font-weight: normal;
    /*background: url(../../../../assets/images/icon-n1.png) no-repeat center center;*/
    /*background-size: 100% 100%;*/
  }

  .icon-2 {
    .icon-1();
    /*background: url(../../../../assets/images/icon-n2.png) no-repeat center center;*/
    /*background-size: 100% 100%;*/
  }

  button {
    /*height: .40rem;*/
    /*line-height: .40rem;*/
    font-size: 0.14rem;
  }

  .mybtn {
    position: relative;

    i {
      font-size: 0.18rem;
      vertical-align: middle;
      color: #ffffff;
      margin-right: 10px;
      margin-top: -0.02rem;
    }
  }
}

.aside-left {
  box-sizing: border-box;
  background-color: #ffffff;
  margin-right: @mg;
  overflow-y: auto;
  position: relative;
  z-index: 103;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);

  .cred {
    color: #ec1c1c;
  }

  .list {
    position: relative;
    cursor: pointer;
    width: 1.8rem;
    height: 190px;
    margin: 0.2rem auto;
    border-radius: 4px;
    overflow: hidden;
    border: 0.02rem solid #e5e5e5;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);
    i.icon {
      position: absolute;
      top: 0;
      right: 0;
      width: 0.4rem;
      height: 0.4rem;
      background-size: cover;
      cursor: pointer;
      z-index: 1;
    }
    .bx {
      width: 100%;
      height: 100px;
      text-align: center;
      line-height: 100px;
      position: relative;

      img {
        height: 55px;
        width: auto;
      }
    }

    p.title {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      padding: 0 10px;
      text-align: center;
      height: 45px;
      width: 100%;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #290202;
      line-height: 23px;
    }
  }

  .list.active {
    border-color: #ec1c1c;
  }

  .page-total {
    color: #646464;
    font-size: 85%;
    border-bottom: 1px solid #f2f2f2;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 60px;
    box-sizing: border-box;

    .tit {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .aside-left_flex {
    display: flex;
    justify-content: space-between;
    padding-left: 0.1rem;
  }
  .page-con {
    overflow-y: auto;
    /*position: absolute;*/
    /*width: 100%;*/
    /*left: 0;*/
    /*bottom: 0.1rem;*/
    /*top: 60px;*/
  }
}

.jump-edit {
  top: -139px;
  bottom: initial;
  pointer-events: initial;
}

.jumpFirst {
  top: -80px;
  bottom: initial;
  pointer-events: initial;
}

.jumpLast {
  top: -25px;
  bottom: initial;
  pointer-events: initial;
}
</style>



// WEBPACK FOOTER //
// pages/initiation/components/cooperateWith/toCreateNew.vue